interface AvatarProps {
  initials: string;
  color?: string;
  size?: number;
  ring?: boolean;
}

export function Avatar({ initials, color = '#6739FD', size = 28, ring = false }: AvatarProps) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: color,
        color: 'white',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size * 0.4,
        fontWeight: 700,
        letterSpacing: '0.02em',
        boxShadow: ring ? '0 0 0 2px white, 0 0 0 3px var(--line)' : undefined,
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
}

interface AvatarStackProps {
  users: { initials: string; color: string }[];
  size?: number;
}

export function AvatarStack({ users, size = 24 }: AvatarStackProps) {
  return (
    <div style={{ display: 'inline-flex' }}>
      {users.map((u, i) => (
        <div key={i} style={{ marginLeft: i === 0 ? 0 : -8 }}>
          <Avatar initials={u.initials} color={u.color} size={size} ring />
        </div>
      ))}
    </div>
  );
}
